import * as React from 'react';
import {assets} from "../../helpers";
import {Map} from '../../components/Map';

declare const require: any;
const $: any = require('jquery');

let heading: any;
let cache: any;

function anim(data) {
    let animate = function (current) {
        $('.heading .cover').animate({opacity: 0}, function () {
            $('.heading .cover').css({background: 'url(/assets/heading/' + data[current] + ')'});
            $('.heading .cover').animate({opacity: 1});
        });
    };
    
    let current = 0,
        changeHeadingBackground = function () {
            animate(current);
            if (++current >= data.length) {
                current = 0;
            }
        };
    
    let interval = setInterval(changeHeadingBackground, 5000);
    $('.heading .cover').on('click', '.leftArrow, .rightArrow', function (e) {
        e.preventDefault();
        clearInterval(interval);
        if ($(this).hasClass('leftArrow')) {
            current--;
            if (current < 0) {
                current = data.length - 1;
            }
        } else if ($(this).hasClass('rightArrow')) {
            current++;
            if (current >= data.length) {
                current = 0;
            }
        }
        
        animate(current);
    });
    
    return interval;
}

export class AboutConference extends React.Component<any, any> {
    private animationInterval: number;
    
    componentDidMount() {
        if (!heading) {
            $.getJSON('/assets/heading.json', (data) => {
                cache = data.map(function (image) {
                    let cache = new Image();
                    cache.src = assets('/heading/' + image);
                    return cache;
                });
        
                this.animationInterval = anim(data);
            });
        } else {
            this.animationInterval = anim(heading);
        }
    }
    
    componentWillUnmount() {
        clearInterval(this.animationInterval);
    }
    
    render() {
        return (
            <section className="heading">
                <a name="about" />
                <div className="cover" style={{opacity: 1, background: `url(${assets("/heading/5.jpg")})`}}>
                    <a href="#" className="leftArrow" />
                    <a href="#" className="rightArrow" />
                </div>
                <div className="desc">
                    <h1>Loudhead - это самое громкое событие года среди настоящих любителей звука.</h1>
                    <p>Ежегодно компания Doctorhead собирает в одном месте самых лучших производителей персонального аудио: наушников, плееров, усилителей - и сотни ценителей хорошего звука. Loudhead - это уникальная возможность не только протестировать большую часть самого лучшего  портативного аудио, представленного на рынке и легендарные раритетные модели, но и продемонстрировать собственные системы и аудио-компоненты, обменяться мнениями и новостями, и отлично провести время в компании единомышленников.</p>
                </div>
                <div className="icons">
                    <a href="http://vk.com/share.php?url=http%3A%2F%2Floudhead.ru%2F%3Fvk" target="_blank" className="icon icon-vk" />
                    <a href="http://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Floudhead.ru%2F%3Ffb" target="_blank" className="icon icon-fb" />
                    <a href="http://twitter.com/share?url=http%3A%2F%2Floudhead.ru%2F%3Ftw" target="_blank" className="icon icon-tw" />
                </div>
                <Map />
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Main/AboutConference.tsx
 **/